import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  QueryList,
  signal,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { PmPagesNavigatorComponent } from './pm-pages-navigator/pm-pages-navigator.component';

@Component({
  selector: 'pm-pages-slider',
  imports: [CommonModule, PmPagesNavigatorComponent],
  templateUrl: './pm-pages-slider.component.html',
  styleUrl: './pm-pages-slider.component.scss',
})
export class PmPagesSliderComponent {
  @Input({ required: true }) pages!: TemplateRef<any>[];
  @ViewChild('pagesSliderContainer')
  pagesSliderContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('pagesNavigator') pagesNavigator!: PmPagesNavigatorComponent;
  @ViewChildren('pageContainer') pageContainers!: QueryList<
    ElementRef<HTMLDivElement>
  >;
  @Output() pageScroll = new EventEmitter();

  @HostListener('document:keydown', ['$event'])
  onKeydown(e: any) {
    const currentScroll = this.pagesSliderContainer.nativeElement.scrollTop;
    const slideHeight = window.innerHeight;
    const currentSlide = Math.round(currentScroll / slideHeight);

    if (e.key === 'ArrowDown' && currentSlide < this.pages.length - 1) {
      this.scrollToSlide(currentSlide + 1);
    } else if (e.key === 'ArrowUp' && currentSlide > 0) {
      this.scrollToSlide(currentSlide - 1);
    }
  }

  onPageScroll() {
    const scrollPosition = this.pagesSliderContainer.nativeElement.scrollTop;
    const slideHeight = window.innerHeight;
    let currentSlide = Math.round(scrollPosition / slideHeight);

    if (currentSlide > this.pages?.length - 1) {
      currentSlide = this.pages?.length - 1;
    }

    this.pagesNavigator.updateDotsStatus(currentSlide);
    this.pageScroll.emit(scrollPosition);
  }

  scrollToSlide(index: number) {
    const page = this.pageContainers.get(index)?.nativeElement;
    if (!page) return;
    page.scrollIntoView({ behavior: 'smooth' });
  }
}
